import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axiosInstance";
import './css/Eventos.css';
import { Container, Form, Button } from "react-bootstrap";

function EditarEvento() {
  const { id } = useParams();
  const [evento, setEvento] = useState(null);
  const [formulario, setFormulario] = useState({
    nombre: '',
    fecha_inicio: '',
    fecha_fin: '',
    estado: ''  
  });

  const navegar = useNavigate();
   const navigate = useNavigate();

 useEffect(() => {
  const obtenerEvento = async () => {
    try {
      const respuesta = await axios.get(process.env.REACT_APP_BACKEND_URL + `/api/eventos/${id}`);
      const eventoRecibido = respuesta.data.evento;
      setEvento(eventoRecibido);
      setFormulario({
        nombre: eventoRecibido.nombre,
        fecha_inicio: eventoRecibido.fecha_inicio,
        fecha_fin: eventoRecibido.fecha_fin,
      });
    } catch (error) {
      console.error("Error al cargar evento:", error);
    }
  };

  obtenerEvento();
}, [id]);


  const manejarCambio = (e) => {
    setFormulario({
      ...formulario,
      [e.target.name]: e.target.value
    });
  };
   const volver = () => {
    navigate(-1); 
  };

  const guardarCambios = async (e) => {
    e.preventDefault();
    try {
      await axios.put(process.env.REACT_APP_BACKEND_URL + `/api/eventos/${id}`, formulario);
      alert("Evento actualizado correctamente");
      navegar('/eventos');
    } catch (error) {
      console.error("Error al actualizar el evento:", error);
    }
  };

  if (!evento) return <p>Cargando...</p>;

  return (
    <Container className="contenedorEventos mt-5" style={{ maxWidth: '1000px' }}>
       <Button  className="boton_accion" size="sm" onClick={volver}> ⬅ Volver</Button>
      <h2 className="tituloEvento mt-2 text-center">Editar Evento: {evento.nombre}</h2>
      <Form onSubmit={guardarCambios}>
        <Form.Group className="mb-3" controlId="nombreEvento">
          <Form.Label>Nombre del Evento:</Form.Label>
          <Form.Control
            type="text"
            name="nombre"
            value={formulario.nombre}
            onChange={manejarCambio}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="fechaInicio">
          <Form.Label>Fecha de Inicio:</Form.Label>
          <Form.Control
            type="date"
            name="fecha_inicio"
            value={formulario.fecha_inicio}
            onChange={manejarCambio}
            required
          />
        </Form.Group>

        <Form.Group className="mb-4" controlId="fechaFin">
          <Form.Label>Fecha de Fin:</Form.Label>
          <Form.Control
            type="date"
            name="fecha_fin"
            value={formulario.fecha_fin}
            onChange={manejarCambio}
            required
          />
        </Form.Group>
        
        <Button  type="submit" className=" boton_accion w-100">
          Guardar Cambios
        </Button>
      </Form>
    </Container>
  );
}

export default EditarEvento;
